// extracted by mini-css-extract-plugin
module.exports = {"table":"table-6REji"};